export function toLocalTime(utcDate: Date) {
  const localDate = new Date(
    utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
  );
  const day = ('0' + localDate.getDate()).slice(-2);
  const month = ('0' + (localDate.getMonth() + 1)).slice(-2);
  const year = localDate.getFullYear();

  let hours = localDate.getHours();
  const minutes = ('0' + localDate.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = ('0' + hours).slice(-2);

  return `${month}/${day}/${year} ${strHours}:${minutes} ${ampm}`;
}

function isDateFormatted(value: string): boolean {
  const regex = /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} (AM|PM)$/;
  return regex.test(value);
}

function isUnformatted(value: string): boolean {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return regex.test(value);
}

export function isDateFormat(value: any): boolean {
  if (typeof value !== 'string') {
    return false;
  }
  return isDateFormatted(value) || isUnformatted(value);
}

export function convertToDate(value: string): string | null {
  if (isDateFormat(value)) {
    return toLocalTime(new Date(value));
  } else {
    return null;
  }
}

/**
 * Converts any date-like value (ISO string, Date, timestamp string) to a local Date object
 * without timezone shift. Returns null for invalid or empty input.
 */
export function toDateInputValue(raw: unknown): Date | null {
  if (raw == null || raw === '') return null;
  if (raw instanceof Date) return isNaN(raw.getTime()) ? null : raw;
  const str = String(raw).trim();
  if (!str) return null;
  const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const d = new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
    /* istanbul ignore next — new Date(y,m,d) with integers never produces NaN */
    return isNaN(d.getTime()) ? null : d;
  }
  const cleaned = str.endsWith('Z') ? str.slice(0, -1) : str;
  const d = new Date(cleaned);
  if (isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Formats a Date as YYYY-MM-DD string. Returns empty string for null/invalid. */
export function toIsoDateString(date: Date | null | undefined): string {
  if (!date || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function convertToUTC(dateString?: string, setEndOfDay: boolean = false): string | undefined {
  if (!dateString) {
    return undefined;
  }

  const date = new Date(dateString);
  if (setEndOfDay) {
    date.setUTCHours(23, 59, 59, 999);
  }

  return date.toISOString();
}